import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { RouteConfig } from 'vue-router'
import { aiEvaluationsRouteNames } from '../constants/location'
import { requireAuthAndLocation } from '../auth'

const AIEvaluations = () => import('@/apps/aiEvaluations/AIEvaluations.vue').then(m => m.default)
const AskAIEvaluation = () => import('@/apps/aiEvaluations/AskAIEvaluation.vue').then(m => m.default)

export const aiEvaluationsRoute: RouteConfig[] = [
  {
    path: 'ai-evaluations',
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: '',
        name: aiEvaluationsRouteNames.default,
        component: AIEvaluations,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'ask-ai',
        name: aiEvaluationsRouteNames.askAiEvaluation,
        component: AskAIEvaluation,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
]

